import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormGroupErrorMessageComponent, noWhitespaceValidator, Utils,
  LoadingPanelService, AlertService, AlertIcon, ResponseAlert} from 'lib-base';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { firstValueFrom, forkJoin, Subscription } from 'rxjs';
import { PortalUsuarioService } from '../../../../services/portalUsuario.service';
import { AuthenticationManagerService } from '../../../../services/authentication-manager.service';
import { RecaptchaV3Module, ReCaptchaV3Service } from 'ng-recaptcha';
import { SolicitudRestablecerPasswordRequest } from '../../../../shared/interfaces/seguridad';
import {IconFieldModule} from "primeng/iconfield";
import {InputIconModule} from "primeng/inputicon";
import {ToastModule} from "primeng/toast";

@Component({
  selector: 'app-password-reset-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormGroupErrorMessageComponent,
    ButtonModule, InputTextModule, TranslateModule, RecaptchaV3Module, IconFieldModule, InputIconModule, ToastModule],
  templateUrl: './password-reset-form.component.html',
  styleUrl: './password-reset-form.component.scss'
})
export class PasswordResetFormComponent implements OnInit, OnDestroy {

  form !: FormGroup;
  private _translations: any = {};

  recaptchaSubscription !: Subscription;

  constructor(private _fb: FormBuilder, private _ms: MessageService, private _t: TranslateService, private _pu: PortalUsuarioService,
    private _am: AuthenticationManagerService, private recaptchaV3Service: ReCaptchaV3Service,
              private readonly alertService:AlertService, private readonly loadingService:LoadingPanelService
  ) {
    this.configureForm();
  }

  ngOnDestroy(): void {
    if(this.recaptchaSubscription){
      this.recaptchaSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.translate();
  }

  private async translate(): Promise<void> {
    this._translations = await firstValueFrom(forkJoin({
      warnSummary: this._t.get('form.msg.warn-summary'),
      successSummary: this._t.get('form.msg.success-summary'),
      errorSummary: this._t.get('form.msg.error-summary'),
      completeCampos: this._t.get('form.msg.complete-campos'),
      siguiente: this._t.get('form.button.siguiente'),
      emailSent: this._t.get('components.app-password-reset-form.email-sent'),
    }));
  }

  configureForm() {
    this.form = this._fb.group({
      correo: [null, [Validators.required, noWhitespaceValidator]],
    });
  }

  //#region API Calls
  solicitudRestablecerPassword(request: SolicitudRestablecerPasswordRequest) {
    this.loadingService.show();
    this._pu.solicitudRestablecerPassword(request).subscribe({
      next: (response) => {
        this.alertService.show({
          text: this._translations.emailSent,
          icon: AlertIcon.SUCCESS,
          showAccept: true,
           textAccept: this._translations.siguiente
        }).subscribe(async (result: ResponseAlert) => {
          this._am.onMenuClose();
        });
      },complete:()=> this.loadingService.hide(),
    });
  }
  //#endregion

  onClear() {
    this.form.reset();
  }

  onSubmit() {
    if (this.form.invalid) {
      Utils.markAllFormControlsAsTouched(this.form);
      this._ms.add({ severity: 'warn', summary: this._translations.warnSummary, detail: this._translations.completeCampos });
      return;
    }

    this.recaptchaSubscription = this.recaptchaV3Service.execute('solicitudRestablecerPassword')
      .subscribe((token) => {

        let request = {
          correo: this.form.get('correo')?.value,
          captchaToken: token
        } as SolicitudRestablecerPasswordRequest

        this.solicitudRestablecerPassword(request);
      });

  }

  onBack() {
    this._am.onOpenTab(0);
  }
}
